'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSharedLayoutCompatible = undefined;

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

var _constants = require('./constants');

var _src = require('../../rules2/src');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var isTableLayoutCompatible = function isTableLayoutCompatible(data, layout) {
  var combinationsDefinitions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var dataquery = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

  var indexedCombinations = R.indexBy(R.prop('id'), combinationsDefinitions);
  var indexedManyValuesDimensions = R.pipe(R.pathOr([], ['structure', 'dimensions', 'observation']), function (dimensions) {
    return (0, _src.refineDimensions)(dimensions, dataquery);
  }, R.reject(function (d) {
    return R.prop('header', d) || !R.length(d.values || []);
  }), R.indexBy(R.prop('id')))(data);
  var remainings = indexedManyValuesDimensions;
  var layoutIds = R.pipe(R.values, R.unnest)(layout);
  var hasFoundIrrelevant = false;
  R.forEach(function (id) {
    if (R.has(id, indexedManyValuesDimensions)) {
      remainings = R.dissoc(id, remainings);
    } else if (R.has(id, indexedCombinations)) {
      remainings = R.omit(R.pathOr([], [id, 'concepts'], indexedCombinations), remainings);
    } else if (id !== 'OBS_ATTRIBUTES') {
      hasFoundIrrelevant = true;
    }
  }, layoutIds);
  return R.isEmpty(remainings) && !hasFoundIrrelevant;
};

var isScatterLayoutCompatible = function isScatterLayoutCompatible(data, chartDimension) {
  var id = chartDimension.id,
      xId = chartDimension.xId,
      yId = chartDimension.yId;


  var dimensions = R.pathOr([], ['structure', 'dimensions', 'observation'], data);

  var dimension = R.find(R.propEq('id', id), dimensions);
  if (R.isNil(dimension)) {
    return false;
  }
  return R.pipe(R.propOr([], 'values'), R.indexBy(R.prop('id')), R.pick([xId, yId]), R.values, R.length, R.equals(2))(dimension);
};

var isSymbolLayoutCompatible = function isSymbolLayoutCompatible(data, chartDimension) {
  var id = chartDimension.id,
      serie = chartDimension.serie;

  var serieIds = R.pluck('id', serie);

  return R.pipe(R.pathOr([], ['structure', 'dimensions', 'observation']), R.indexBy(R.prop('id')), R.pathOr([], [id, 'values']), R.indexBy(R.prop('id')), R.pick(serieIds), R.values, R.length, R.equals(R.length(serieIds)))(data);
};

var isStackedLayoutCompatible = function isStackedLayoutCompatible(data, chartDimension) {
  var id = chartDimension.id;


  return R.pipe(R.pathOr([], ['structure', 'dimensions', 'observation']), R.filter(R.pipe(R.propOr([], 'values'), R.length, R.lt(1))), R.indexBy(R.prop('id')), R.has(id))(data);
};

var isChartLayoutCompatible = function isChartLayoutCompatible(data, type, chartDimension) {
  return R.cond([[R.always(R.equals(_constants.SCATTER, type)), isScatterLayoutCompatible], [R.always(R.equals(_constants.H_SYMBOL, type) || R.equals(_constants.V_SYMBOL, type)), isSymbolLayoutCompatible], [R.always(R.anyPass([R.equals(_constants.STACKED_BAR), R.equals(_constants.STACKED_ROW)])(type)), isStackedLayoutCompatible], [R.T, R.T]])(data, chartDimension);
};

var isSharedLayoutCompatible = exports.isSharedLayoutCompatible = function isSharedLayoutCompatible(sdmxData, sharedData) {
  var type = R.prop('type', sharedData);
  if (type === 'table') {
    var layoutIds = R.pathOr({}, ['config', 'table', 'layoutIds'], sharedData);
    var dataquery = R.path(['config', 'sdmxSource', 'dataquery'], sharedData);
    var annotations = R.pathOr({}, ['structure', 'annotations'], sdmxData);
    var locale = R.pathOr({}, ['config', 'table', 'locale'], sharedData);
    var rawDefaultCombinationsDefinition = R.pathOr({}, ['config', 'defaultCombinations'], sharedData);
    var _rawDefaultCombinatio = rawDefaultCombinationsDefinition.concepts,
        concepts = _rawDefaultCombinatio === undefined ? '' : _rawDefaultCombinatio,
        _rawDefaultCombinatio2 = rawDefaultCombinationsDefinition.names,
        names = _rawDefaultCombinatio2 === undefined ? '' : _rawDefaultCombinatio2;

    var defaultCombinationsDefinition = (0, _src.parseCombinationDefinition)(locale)(concepts, names);
    var customCombinationsDefinitions = (0, _src.getCombinationDefinitions)(annotations, locale);
    var combinationsDefinitions = R.isNil(customCombinationsDefinitions) || R.isEmpty(customCombinationsDefinitions) ? defaultCombinationsDefinition : customCombinationsDefinitions;
    return isTableLayoutCompatible(sdmxData, layoutIds, combinationsDefinitions, dataquery);
  }
  var chartDimension = R.pathOr({}, ['config', 'chart', 'chartDimension'], sharedData);
  return isChartLayoutCompatible(sdmxData, type, chartDimension);
};